import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import Favorites from "./Favorites";
import Billing from "./Billing";
import Company from "./Company";
import TimesheetsReport from "./TimesheetsReport";
import EVV_Reports from "./EVV_Reports";
import SupportCoordination_Reports from "./SupportCoordination_Reports";
import CMCustomerReports from "./CMCustomerReports";
import Scheduler_Reports from "./Scheduler_Reports";
import HomeHealthcare_Reports from "./HomeHealthcare_Reports";
import CareManagement_Reports from "./CareManagement_Reports";
import BI_Dashboards from "./BI_Dashboards";
import PaidOutlined from "@mui/icons-material/PaidOutlined";
import AdministrationReports from "./Administration_Reports";
import ScheduleReports from "./ScheduleReports";
import CustomReportsManager from "./CustomReportsManager";


export default function Reports(props) {
    // { "primaryBusinessType": "Support Coordination", "featureValue": 101 },
    // { "primaryBusinessType": "Service Providers", "featureValue": 102 },
    // { "primaryBusinessType": "Home Healthcare", "featureValue": 103 },
    // { "primaryBusinessType": "Case Management", "featureValue": 104 },
    // { "primaryBusinessType": "Daycare Centers", "featureValue": 105 },
    // { "primaryBusinessType": "Group Home", "featureValue": 106 },
    const pBusinessType = props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : 101;

    const getDefaultSubKey = () => {
        switch (pBusinessType) {
            case 101: return 'planRenewal';
            case 102: return 'planRenewal';
            case 103: return 'planRenewal';
            case 104: return 'employeeNotes';
            case 105: return 'planRenewal';
            default: return 'planRenewal';
        }
    };

    const [activeKey, setActiveKey] = useState('favorites');
    const [activeSubKey, setActiveSubKey] = useState(getDefaultSubKey());

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);

        if (activeKey === 'evv') {
            setActiveSubKey('evvReport');
        } else if (activeKey === 'scheduleManagement') {
            setActiveSubKey('clientAttendance');
        } else if (activeKey === 'supportCoordination') {
            setActiveSubKey('scVisit');
        } else if (activeKey === 'homeHealthcare') {
            setActiveSubKey('homeVisits');
        } else if (activeKey === 'careManagement') {
            setActiveSubKey('emar');
        } else if (activeKey === 'biDashboards') {
            setActiveSubKey('demographicsDashboard');
        } else {
            setActiveSubKey(getDefaultSubKey());
        }
    };

    const navigateToFavoriteReport = (activeKey, activeSubKey) => {
        setActiveKey(activeKey);
        setActiveSubKey(activeSubKey);
    };

    const tabs = [
        { key: 'favorites', label: "Favorites", component: Favorites },
        { key: 'customReports', label: "Custom Reports", component: CustomReportsManager },
        { key: 'administration', label: "Administration", component: AdministrationReports },
        ...(props.user.permissions.TimeManagementReports ? [{ key: 'timeManagement', label: "Time Management", component: TimesheetsReport }] : []),
        ...([103, 106].includes(pBusinessType) ? [{ key: 'careManagement', label: "Care Management", component: CareManagement_Reports }] : []),
        ...(props.user.permissions.BillingReports ? [{ key: 'billing', label: "Billing", component: Billing }] : []),
        ...(props.user.permissions.CompanyReports ? [{ key: 'company', label: "Company", component: Company }] : []),
        ...(props.user.permissions.EVVReports ? [{ key: 'evv', label: "EVV", component: EVV_Reports }] : []),
        ...(props.user.permissions.SupportCoordinationReports ? [{ key: 'supportCoordination', label: "Support Coordination", component: SupportCoordination_Reports }] : []),
        ...(props.user.permissions.CaseManagementReports ? [{ key: 'caseManagement', label: "Case Management", component: CMCustomerReports }] : []),
        ...(props.user.permissions.ScheduleManagementReports ? [{ key: 'scheduleManagement', label: "Schedule Management", component: Scheduler_Reports }] : []),
        ...(pBusinessType === 103 ? [{ key: 'homeHealthcare', label: "Home Healthcare", component: HomeHealthcare_Reports }] : []),
        ...(props.user.permissions.BIDashboards ? [{ key: 'biDashboards', label: "BI Dashboards", component: BI_Dashboards }] : []),
        ...(props.user.permissions.BIDashboards ? [{ key: 'scheduleReports', label: "Report Scheduler", component: ScheduleReports }] : []),
    ];

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Box sx={{ flexGrow: 1, display: 'flex', height: 'calc(100vh - 85px)', minWidth: 0 }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    orientation="vertical"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        width: 'auto',
                        minWidth: '210px',
                        flexShrink: 0,
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                        '& .MuiTab-root': {
                            alignItems: 'flex-start',
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                        },
                    }}
                >
                    {tabs.map((tab, index) => (
                        <Tab
                            key={tab.key}
                            value={tab.key}
                            label={(
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                                    {tab.label}
                                    {['biDashboards', 'scheduleReports'].includes(tab.key) && (
                                        <PaidOutlined fontSize='small' sx={{ mt: -2, ml: 0.5, flexShrink: 0 }} />
                                    )}
                                </Box>
                            )}
                        />
                    ))}
                </Tabs>

                <Box sx={{ width: '100%', position: 'relative', minWidth: 0, overflow: 'hidden auto' }}>
                    {tabs.find(tab => tab.key === activeKey)?.component &&
                        React.createElement(tabs.find(tab => tab.key === activeKey).component,
                            { ...props, navigateToFavoriteReport, activeSubKey })}
                </Box>
            </Box>
        </Box>
    );
};